import React from 'react';
import 'styled-components/macro'
import styled from 'styled-components'
import { Container } from './Container'

const Navbar = styled.nav`
    background-color: #29ABE2;
    padding: 2rem 0;
`

const Nav = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const Link = styled.a`
    color: white;
`

const LogoText = styled.p`
    font-size: 2rem;
    color: white;
`

const Logo = styled.div`
    display: flex;
    align-items: center;
`

const Header = () => {
    return (
        <Navbar> 
            <Container>
                <Nav>
                    <Logo>
                        <Link href={`/`}>
                            <LogoText>
                                ChuckNorris<strong>Jokes</strong>
                            </LogoText>
                        </Link>
                    </Logo>
                    <Link href='https://github.com/sergiopichardo/chuck-norris-jokes' target='_blank'>
                        Repo
                    </Link>
                </Nav>
            </Container>
        </Navbar>
    )
}

export default Header 